module.exports = __webpack_public_path__ + "static/2StoreIcons-bf2f7ab0056dd53735b38748c4c380b4.svg";